import { render, staticRenderFns } from "./StreamplayFeature.vue?vue&type=template&id=f148267a&scoped=true"
import script from "./StreamplayFeature.vue?vue&type=script&lang=js"
export * from "./StreamplayFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f148267a",
  null
  
)

export default component.exports